<template>
  <div class="question-answer-input">
    <OptionList
      v-if="[types.SINGLE, types.MULTI, types.JUDGE].includes(type)"
      :value="value"
      :options="options"
      :multiple="type === types.MULTI"
      :judgment="type === types.JUDGE"
      :name="inputName"
      :disabled="disabled"
      @input="$emit('input', $event)"
    />
    <FillBlankQuestionInput v-else-if="type === types.FILL" :value="value" :disabled="disabled" @input="$emit('input', $event)" />
    <ShortAnswerInput v-else-if="type === types.SHORT" :value="value" :disabled="disabled" @input="$emit('input', $event)" />
    <MatchingQuestionInput v-else-if="type === types.MATCHING" :value="value" :left-options="matchingLefts" :right-options="matchingRights" :disabled="disabled" @input="$emit('input', $event)" />
    <SharedOptionQuestionInput v-else-if="type === types.SHARED_OPTION" :value="value" :sub-questions="sharedQuestions" :options="options" :name="inputName" :disabled="disabled" @input="$emit('input', $event)" />
    <AssessmentQuestionInput v-else-if="type === types.ASSESSMENT" :value="value" :options="assessmentItems" :max-selections="assessmentMax" :disabled="disabled" @input="$emit('input', $event)" />
    <ClockQuestionInput v-else-if="type === types.CLOCK" :value="value" :groups="clockGroups" :disabled="disabled" @input="$emit('input', $event)" />
    <WordSelectQuestionInput v-else-if="type === types.WORD_SELECT" :value="value" :options="wordOptions" :disabled="disabled" @input="$emit('input', $event)" />
    <OptionalQuestionInput v-else-if="type === types.OPTIONAL" :value="value" :sub-questions="optionalItems" :required-count="optionalRequired" :name="inputName" :disabled="disabled" @input="$emit('input', $event)" />
    <ShortAnswerInput v-else :value="value" :disabled="disabled" @input="$emit('input', $event)" />
  </div>
</template>

<script>
import AssessmentQuestionInput from './AssessmentQuestionInput.vue'
import ClockQuestionInput from './ClockQuestionInput.vue'
import FillBlankQuestionInput from './FillBlankQuestionInput.vue'
import MatchingQuestionInput from './MatchingQuestionInput.vue'
import OptionList from './OptionList.vue'
import OptionalQuestionInput from './OptionalQuestionInput.vue'
import SharedOptionQuestionInput from './SharedOptionQuestionInput.vue'
import ShortAnswerInput from './ShortAnswerInput.vue'
import WordSelectQuestionInput from './WordSelectQuestionInput.vue'
import {
  QUESTION_TYPE,
  assessmentMaxSelections,
  assessmentOptions,
  clockConfig,
  getQuestionType,
  matchingLeftOptions,
  matchingRightOptions,
  optionalQuestions,
  optionalRequiredCount,
  questionOptions,
  sharedOptionQuestions,
  wordSelectOptions
} from '@/utils/questionDisplay'

export default {
  name: 'QuestionAnswerInput',
  components: { AssessmentQuestionInput, ClockQuestionInput, FillBlankQuestionInput, MatchingQuestionInput, OptionList, OptionalQuestionInput, SharedOptionQuestionInput, ShortAnswerInput, WordSelectQuestionInput },
  props: {
    question: { type: Object, required: true },
    value: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() { return { types: QUESTION_TYPE } },
  computed: {
    type() { return getQuestionType(this.question) },
    inputName() { return `question-${this.question.question_id || this.question.id || 'unknown'}` },
    options() { return questionOptions(this.question) },
    matchingLefts() { return matchingLeftOptions(this.question) },
    matchingRights() { return matchingRightOptions(this.question) },
    sharedQuestions() { return sharedOptionQuestions(this.question) },
    assessmentItems() { return assessmentOptions(this.question) },
    assessmentMax() { return assessmentMaxSelections(this.question) },
    clockGroups() { return clockConfig(this.question) },
    wordOptions() { return wordSelectOptions(this.question) },
    optionalItems() { return optionalQuestions(this.question) },
    optionalRequired() { return optionalRequiredCount(this.question) }
  }
}
</script>

<style scoped>.question-answer-input { min-width: 0; }</style>
